import Cookies from 'js-cookie';
/**
 * @description: 函数防抖，只执行最后一次操作
 * @param {type}
 * @return:
 */
export const debounce = (fn: Function, time = 500) => {
  let timer: any = null;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(args);
    }, time);
  };
};
/**
 * @description: 函数节流
 * @param {type}
 * @return:
 */
export const throttle = (fn: Function, time = 500) => {
  let timer: any = null;
  let startTime: any = new Date();
  const curTime: any = new Date();
  return (...args: any[]) => {
    clearTimeout(timer);
    if (curTime - startTime >= time) {
      fn(args);
      startTime = curTime;
    } else {
      timer = setTimeout(() => {
        fn(args);
      }, time);
    }
  };
};
/**
 * @description: 入参map对象字典排序
 * @param {type}
 * @return:
 */
export const objKeySort = (obj: object) => {
  const newKey = Object.keys(obj).sort();
  const newObj = {};
  for (let i = 0; i < newKey.length; i += 1) {
    (newObj as any)[newKey[i]] = (obj as any)[newKey[i]];
  }
  return newObj;
};
/**
 * @description: 存sessionStorage
 * @param {type}
 * @return:
 */
export const writeStorage = (key: string, val: any) => {
  let value: any = val;
  if (value) {
    value = JSON.stringify(value);
  }
  sessionStorage.setItem(key, value);
};

/**
 * @description: 取sessionStorage
 * @param {type} key
 * @return: string
 */
export const readStorage = (key: string) => {
  const value = sessionStorage.getItem(key);
  if (value && value !== 'undefined') {
    return JSON.parse(value);
  }
  return null;
};
export const removeStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
export const writeCookie = (key: string, val: any) => {
  let value: any = val;
  if (value) {
    value = JSON.stringify(value);
  }
  Cookies.set(key, value);
};
/**
 * @description: 取localstorage
 * @param {type} key
 * @return: string
 */
export const readCookie = (key: string) => {
  const value = Cookies.get(key);
  if (value && value !== 'undefined') {
    return JSON.parse(value);
  }
  return null;
};
/**
 * @description: 删除localstorage
 * @param {type} key
 * @return: string
 */
export const removeCookie = (key: string) => {
  Cookies.remove(key);
};
const checkAddZone = (num: any) => (num < 10 ? `0${num.toString()}` : num);
export const dateFormatter = (nows: string) => {
  if (!nows) return '';
  const now = new Date(nows);
  const year = now.getFullYear();

  let month = now.getMonth() + 1;
  month = checkAddZone(month);

  let date = now.getDate();
  date = checkAddZone(date);
  return `${year}-${month}-${date}`;
};

export const dateTimeFormatter = (t: any) => {
  let time = t;
  if (!time) return '';
  time = new Date(time).getTime();
  time = new Date(time);
  const year = time.getFullYear();
  let month = time.getMonth() + 1;
  month = checkAddZone(month);

  let date = time.getDate();
  date = checkAddZone(date);

  let hour = time.getHours();
  hour = checkAddZone(hour);

  let min = time.getMinutes();
  min = checkAddZone(min);

  let se = time.getSeconds();
  se = checkAddZone(se);

  return `${year}-${month}-${date} ${hour}:${min}:${se}`;
};

// 时间戳转换为时分秒倒计时
export const countDown = (timestamp: number) => {
  const timer = setInterval(() => {
    const nowTime = new Date();
    const endTime = new Date(timestamp * 1000);
    const t = endTime.getTime() - nowTime.getTime();
    const hours = Math.floor((t / 1000 / 60 / 60) % 24);
    const minutes = Math.floor((t / 1000 / 60) % 60);
    const seconds = Math.floor((t / 1000) % 60);
    const timehours = hours < 10 ? `0${hours}` : hours;
    const timeminutes = minutes < 10 ? `0${minutes}` : minutes;
    const timeseconds = seconds < 10 && seconds >= 1 ? `0${seconds}` : seconds;
    return `${timehours} :${timeminutes} :${timeseconds}`;
  }, 1000);
};

export const secondToDate = (result: number) => {
  const h = Math.floor(result / 3600) < 10 ? `0${Math.floor(result / 3600)}` : Math.floor(result / 3600);
  const m = Math.floor((result / 60) % 60) < 10
    ? `0${Math.floor((result / 60) % 60)}`
    : Math.floor((result / 60) % 60);
  const s = Math.floor(result % 60) < 10 ? `0${Math.floor(result % 60)}` : Math.floor(result % 60);
  return `${h}时${m}分${s}秒`;
};

export const secondToTime = (result: number) => {
  const h = Math.floor(result / 3600) < 10 ? `0${Math.floor(result / 3600)}` : Math.floor(result / 3600);
  const m = Math.floor((result / 60) % 60) < 10
    ? `0${Math.floor((result / 60) % 60)}`
    : Math.floor((result / 60) % 60);
  return `${h}时${m}分`;
};

// 获取url链接中指定参数
export const getQueryString = (name: string) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
// 千分位加逗号
export const formatNum = (value: string) => {
  let newStr = '';
  let count = 0;
  for (let i = value.length - 1; i >= 0; i -= 1) {
    if (count % 3 === 0 && count !== 0) {
      newStr = `${value.charAt(i)},${newStr}`;
    } else {
      newStr = value.charAt(i) + newStr;
    }
    // count++;
    count += 1;
  }
  // eslint-disable-next-line no-param-reassign
  value = newStr; // 自动补小数点后两位
  return value;
};
